<template>
	<div class="login">
    <!-- 账号登录 -->
		<a-card class="card" v-if="!isLogin" :body-style="{ padding: '100px 40px' }">
			<div class="logo-wrapper">
				<span class="title">欢迎登录 <br>医事服务管理系统</span>
			</div>
			<a-form :form="form" class="login-form">
				<a-form-item>
					<a-input
						v-decorator="[
							'username',
							{
								rules: [{ required: true, message: '请输入用户名' }],
								validateTrigger: 'change',
							},
						]"
						size="large"
						placeholder="用户名"
					>
						<a-icon
							slot="prefix"
							type="user"
							:style="{ color: 'rgba(0,0,0,.25)' }"
						/>
					</a-input>
				</a-form-item>

				<a-form-item>
					<a-input
						v-decorator="[
							'password',
							{
								rules: [
									{ required: true, message: '请输入密码' },
									{
										pattern: /^[a-zA-Z0-9]{4,16}$/g,
										message: '密码必须为4-16位的字母数字组合',
									},
								],
								validateTrigger: 'blur',
							},
						]"
						size="large"
						type="password"
						autocomplete="false"
						placeholder="密码"
					>
						<a-icon
							slot="prefix"
							type="lock"
							:style="{ color: 'rgba(0,0,0,.25)' }"
						/>
					</a-input>
				</a-form-item>

				<a-form-item style="margin-top: 24px; margin-bottom: 0;">
					<a-button
						@click="handleLogin"
						:loading="loading"
						:disabled="loading"
						size="large"
						type="primary"
						class="login-button"
						>登录</a-button
					>
				</a-form-item>
			</a-form>
		</a-card>
    <!-- IP安全验证 -->
    <safety-ver
    v-if="isLogin && !isExist"
    :showPhone="showPhone"
    :phone="phone"
    :codeHint="codeHint"
    @phoneLogin="phoneLogin"
    @goBack="goBack"
    />
    <!-- 谷歌令牌验证 -->
    <google-token
    v-if="isLogin && isExist"
    ref="resetCode"
    :isBind="isBind"
    :qrCode="qrCode"
    :googleSecret="googleSecret"
    :showPhone="showPhone"
    :phone="phone"
    @phoneLogin="phoneLogin"
    @getQrCode="getQrCode"
    @goBack="goBack"
    @checkQrCode="checkQrCode" />
    <!-- 底部 -->
		<div class="login-footer">
			<layout-footer></layout-footer>
		</div>
    <!-- 登录绑定手机号码 弹窗 -->
    <a-modal
    :visible="bindPhoneVisible"
    :footer="null"
    :closable="false"
    width="440px"
    :maskClosable="false">
      <div class="bind-phone">
        <h2 class="title">绑定手机号</h2>
        <a-input placeholder="请输入手机号" v-model="bindPhone" @blur="testPhone"></a-input>
        <p class="hint">{{ bindPhoneHint }}</p>
        <phone-code
        :code="bindCode"
        :phoneHint="bindPhoneHint"
        :phone="bindPhone"
        @getCode="getCode"/>
        <p class="hint">{{ bindCodeHint }}</p>
        <a-button type="primary" @click="phoneLogin('bind')" block>绑定手机号</a-button>
      </div>
    </a-modal>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import LayoutFooter from '@/components/Layout/App/LayoutFooter'
import GoogleToken from './components/google-token.vue'
import SafetyVer from './components/safety-ver.vue'
import PhoneCode from './components/phone-code.vue'
import { timeFix } from '@/utils/time'
import { checkCode, saveUser, getQrCode, resetQrCode, checkQrCode, addPrivate } from '@/api/auth'

export default {
  components: { LayoutFooter, SafetyVer, PhoneCode, GoogleToken },
  data () {
    return {
      // 登录基本信息
      form: this.$form.createForm(this), // 账号登录表单
      loading: false, // 账号登录loading
      isLogin: false, // 是否已经账号登录
      loginInfo: {}, // 登录信息
      browser: '', // 浏览器名称
      userId: '',
      // 安全校验(不在IP白名单)
      codeHint: '', // 验证码校验提示
      // 谷歌令牌，IP名单校验
      isExist: '', // 是否在IP白名单内
      isBind: '', // 是否首次验证谷歌令牌
      googleSecret: '', // 谷歌令牌秘钥
      qrCode: '', // 谷歌令牌二维码
      phone: '', // 绑定的手机号
      // 绑定手机号码
      bindPhoneVisible: false,
      bindPhone: '', // 输入的手机号
      bindPhoneHint: '', // 手机号校验提示
      bindCode: '', // 绑定手机号验证码
      bindCodeHint: '', // 验证码校验提示
      uri: '' // 登录成功默认跳转的uri
    }
  },
  created () {
    this.uri = this.$route.query.uri
    console.log(this.uri)
    this.browser = this.GetBrowserInfo()
    sessionStorage.setItem('browserName', this.browser)
  },
  methods: {
    ...mapActions('user', ['Login']),

    // 获取浏览器名称
    GetBrowserInfo () {
      var agency = navigator.userAgent
      var match = agency.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []
      if (/trident/i.test(match[1])) { return 'IE' }
      match = match[2] ? [match[1], match[2]] : [navigator.appName, navigator.appVersion, '-?']
      return match[0] || 'notName'
    },

    /**
     * 账号登录：账号密码正确 且 不在黑名单 则登录成功
     * isVerify是否验证过： 1-是（测试环境admin账号 不需要验证可直接登录） 0-否
     * isTrust是否信任当前浏览器： 1-是（不需要验证可直接登录） 0-否
     * isExist是否在IP白名单： 1-是 0-否
     * isBind是否首次绑定谷歌令牌： 1-是 0-否
     * 验证流程：
     *  1. 是否有手机号，没有去绑定然后验证IP；有则直接验证IP
     *  2. 验证IP：不在白名单则安全验证，验证成功后直接登录；在白名单则验证谷歌令牌
     *  3. 验证谷歌令牌：是首次验证则扫码输入验证码，验证成功后直接登录；非首次则直接输入验证码，验证成功后直接登录
     *  4. 验证谷歌令牌时也可选择短信验证码登录，非首次谷歌验证可重新绑定谷歌令牌
     *  5. 登录成功验证且没有信任浏览器需要信任浏览器
     */
    handleLogin () {
      this.loading = true
      this.form.validateFields((err, { username, password }) => {
        if (err) {
          setTimeout(() => { this.loading = false }, 600)
          return
        }
        this.Login({
          username,
          password,
          browser: this.browser
        }).then((res) => {
          const info = res.data || {}
          if (info.isVerify || info.isTrust) {
            this.loginSuccess(res)
          } else {
            this.isHavePhone(res)
          }
        }).catch((res) => {
          this.requestFailed(res)
        }).finally(() => (this.loading = false))
      })
    },

    // 登录成功
    loginSuccess (info) {
      const res = info || this.loginInfo
      const loginInfo = Object.assign({ ...res.data })
      delete loginInfo.modules
      sessionStorage.setItem('loginInfo', JSON.stringify(loginInfo))
      sessionStorage.setItem('login', '1')
      sessionStorage.setItem('appIsLogin', '1')
      sessionStorage.setItem('id', res.data.id)
      sessionStorage.setItem('name', res.data.name)
      if (res.data.isTrust) {
        sessionStorage.setItem('isTrust', res.data.isTrust)
      }
      const authority = []
      res.data.modules.forEach((item) => {
        item.menu.forEach((key) => {
          if (key.children) {
            key.children.forEach((value) => {
              if (value.menuList) {
                authority.push({ list: value.menuList, url: value.url })
              }
            })
          }
        })
      })
      sessionStorage.setItem('authority', JSON.stringify(authority))
      // 本地开发环境
      if (res.data.isBoard) {
        sessionStorage.setItem('menuRouteUrl', './website/#/data/home')
      }
      sessionStorage.setItem('isBoard', res.data.isBoard)
      sessionStorage.setItem('snIsBoard', res.data.snIsBoard)
      sessionStorage.setItem('menu', JSON.stringify(res.data))

      // 待app老后台删除后， 这段可删除
      const menuList = res.data.modules.filter((item) => item.id === 99)
      if (menuList.length > 0) {
        sessionStorage.setItem('menuList', JSON.stringify(menuList[0].menu))
      }

      if (this.uri) {
        console.log(this.uri)
        sessionStorage.setItem('menuRouteUrl', this.uri)
      }
      this.$nextTick(() => {
        this.$router.push('/')
      })

      // 延迟 1 秒显示欢迎信息
      setTimeout(() => {
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`
        })
      }, 1000)
    },

    // 是否有手机号码
    isHavePhone (res) {
      if (res.code !== 0) {
        this.$message.error(res.msg || '登录失败')
        return
      }
      this.loginInfo = res
      const info = res.data || {}
      this.userId = info.userId
      if (!info.phone) {
        this.bindPhoneVisible = true
      } else {
        this.isLogin = true
        this.isExistCheck()
      }
    },

    // 关闭绑定手机号弹窗
    closeBindPhone () {
      this.bindPhoneVisible = false
      this.bindPhone = ''
      this.bindPhoneHint = ''
      this.bindCode = ''
      this.bindCodeHint = ''
    },

    // 获取组件内验证码
    getCode (type, code) {
      if (type === 'bind') {
        this.bindCode = code
      }
    },

    /** 是否在IP白名单内
     * isExist： 1-在IP白名单、0-不在IP白名单
     * isBind：1-首次验证谷歌令牌、0-非首次
     */
    isExistCheck () {
      const resData = this.loginInfo && this.loginInfo.data ? this.loginInfo.data : {}
      const _phone = resData && resData.phone
      this.phone = _phone
      this.showMobile(_phone)
      this.isExist = resData.isExist
      this.isBind = resData.isBind
      this.googleSecret = resData.googleSecret
      if (!resData.isBind) { this.getQrCode() }
    },

    // 返回到登录
    goBack () {
      this.isLogin = false
      this.isExist = false
      this.codeHint = ''
    },

    // 手机号脱敏展示
    showMobile (phone) {
      if (phone != null && phone !== undefined) {
        const pat = /(\d{3})\d*(\d{4})/
        const res = phone.replace(pat, '$1****$2')
        this.showPhone = res
      }
    },

    // 手机号验证
    testPhone () {
      const reg = /^1[3456789]\d{9}$/
      const phone = this.bindPhone
      if (phone === '') {
        this.bindPhoneHint = '请输入手机号'
      } else if (phone.length <= 10 || !reg.test(phone)) {
        this.bindPhoneHint = '手机号格式错误'
      } else {
        this.bindPhoneHint = ''
      }
    },

    // 手机验证码登录
    async phoneLogin (type, _code) {
      const resData = this.loginInfo && this.loginInfo.data ? this.loginInfo.data : {}
      let phone = resData.phone
      let code = _code
      let phoneHint = ''
      if (type === 'bind') {
        phone = this.bindPhone
        code = this.bindCode
        phoneHint = this.bindPhoneHint
      }
      const msg = this.verifyPhoneAndCode(phone, phoneHint, code)
      if (msg) {
        this.$message.error(msg)
        return
      }
      const params = { phone, code }
      const res = await checkCode(params)
      console.log('\n\n---type---', type)
      if (res.code !== 0) {
        // if (type === 'bind') {
        //   this.bindCodeHint = '验证码错误'
        // } else if (type === 'login') {
        //   this.codeHint = res.msg || '验证码错误'
        // } else if (type === 'addIp') {
        this.$message.error('验证码错误')
        // }
        return
      }
      if (type === 'bind') { // 绑定手机号
        this.addPrivate()
        this.saveUserPhone(phone)
        this.closeBindPhone()
        this.loginSuccess()
      } else if (type === 'addIp') { // 不在IP白名单，安全验证后加入私有白名单
        this.addPrivate()
      } else if (type === 'reset') { // 重新绑定谷歌令牌验证
        this.resetQrCode()
        this.$refs.resetCode.closeModal()
      } else { // 绑定手机号
        this.loginSuccess()
      }
    },

    // 校验手机号，验证码
    verifyPhoneAndCode (phone, hint, code) {
      let msg = ''
      if (!phone) {
        msg = '请输入手机号'
      }
      if (hint) {
        msg = hint
        this.$message.error(hint)
      }
      if (!code) {
        msg = '请输入验证码'
      }
      return msg
    },

    // 绑定用户手机号
    async saveUserPhone (phone) {
      const params = {
        id: this.userId || '',
        phone: Number(phone)
      }
      const res = await saveUser(params)
      if (res.code !== 0) {
        this.$message.error(res.msg || '修改手机号失败')
      }
    },

    // 获取谷歌令牌
    async getQrCode () {
      const params = { userId: this.userId }
      const res = await getQrCode(params)
      if (res.code === 0) {
        const resData = res.data || {}
        this.googleSecret = resData.googleSecret
        this.qrCode = resData.qrCode
      } else {
        this.$message.error('获取谷歌令牌失败')
      }
    },

    // 重置谷歌令牌
    async resetQrCode () {
      const params = { userId: this.userId }
      const res = await resetQrCode(params)
      if (res.code === 0) {
        this.getQrCode()
        this.isBind = 0
      } else {
        this.$message.error('重置谷歌令牌失败')
      }
    },

    // 校验谷歌令牌
    async checkQrCode (code) {
      if (!code) {
        this.$message.error('请输入验证码')
        return
      }
      const { googleSecret, qrCode, userId } = this
      const params = { googleSecret, code, userId }
      if (qrCode) { params.qrCode = qrCode }
      const res = await checkQrCode(params)
      if (res.code === 0) {
        this.$message.success('验证成功')
        this.loginSuccess()
      } else {
        this.$message.error('验证码错误')
      }
    },

    // 加入私有白名单
    async addPrivate () {
      const res = await addPrivate()
      if (res.code !== 0) {
        this.$message.error(res.msg || '加入私有白名单失败')
      } else {
        this.loginSuccess()
      }
    },

    // 登录失败
    requestFailed (err) {
      if (err.code === 615) {
        this.loginWarning()
        return
      }
      this.$notification.error({
        message: '错误',
        description: (err || {}).msg || '请求出现错误，请稍后再试',
        duration: 4
      })
    },

    // 登录三次提醒
    loginWarning () {
      this.$warning({
        title: '安全提醒',
        content: `您已连续输错密码3次，账号被冻结5分钟，请稍后再试。`,
        okText: '关闭'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  position: relative;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f0f2f5 url('../../assets/images/bj-login.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  min-width: 1400px;

  .card {
    width: 460px;
    border-radius: 20px;
    margin-left: 40%;
    min-width: 450px;
  }

  .logo-wrapper {
    margin-bottom: 38px;
    text-align: left;
    user-select: none;

    .logo {
      display: inline-block;
      width: 80px;
      margin-right: 16px;
    }

    .title {
      font-size: 32px;
      font-weight: bolder;
      font-family: 'Ink Free';
      color: #486dff;
    }
  }

  .login-form {
    margin: 0 auto;

    .login-button {
      padding: 0 15px;
      font-size: 16px;
      height: 40px;
      width: 100%;
    }
  }

  .login-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 0 16px;
    margin: 48px 0 24px;
  }
}
.bind-phone {
  padding: 32px;
  text-align: center;
  h2 {
    margin-bottom: 25px;
  }
  .hint {
    text-align: left;
    color: red;
    height: 20px;
  }
}
</style>
